import {
    LOAD_USER_ACCOUNT_WIZARD,
    IS_USER_ACCOUNT_EXIST,
    IS_GET_STARTED_BTN_DISABLED,
    IS_GET_STARTED_BTN_SHOW,
    IS_PASTED_CODE_REQUEST,
    SET_MESSAGE,
    SET_IMAGE,
    SET_LABEL,
    SET_DESC,
    SET_LINKS,
    SET_LIST,
    IS_WIZARD_NAV_ACTIVE,
    GET_WIZARD_NAV_LENGTH,
    INCREASE_WIZARD_NAV_POSITION,
    IS_DIVIDER_ACTIVE,
    DECREASE_WIZARD_NAV_POSITION,
    SET_IS_GD_UNIT_ADDED_SCRIPT,
    IS_NEXT_BTN_ACTIVE,
    IS_GO_TO_ADSENSE_BTN_SHOW,
    IS_MY_SITE_HAS_BEEN_ADDED,
    SET_WIZARD_NAV_LENGTH,
    VALIDATION_GD_UNIT_CODE
    // IS_GD_SENSE_APP_ACTIVATED
} from '../constants';

const initState = {
    image: 'adsenseIcon',
    isGetStartedBtnDisabled: true,
    isGetStartedBtnShow: true,
    label: 'settings.label.googleAdSense',
    desc: 'settings.desc.googleAdsenseCanTakeTimeToSet',
    links: 'settings.desc.googleAdsenseCanTakeTimeToSet.links',
    isWizardNavStatus: false,
    isDividerActive: false,
    wizardNavLength: 3, // denis - maby have to move it to config or create separate action
    wizardNavPosition: -1, // denis - maby have to move it to config or create separate action
    isAdUnitAddedScript: false,
    isNextBtnActive: false,
    isGoToAdSenseBtnShow: false,
    isMySiteHasBeenAdded: false
}

export default (state = initState, action) => {
    switch (action.type) {
        case LOAD_USER_ACCOUNT_WIZARD:
            return {
                ...state
            }
        case IS_USER_ACCOUNT_EXIST:
            return {
                ...state,
                isUserAccountExist: action.payload
            }
        case IS_GET_STARTED_BTN_DISABLED:
            return {
                ...state,
                isGetStartedBtnDisabled: action.payload
            }
        case IS_GET_STARTED_BTN_SHOW:
            return {
                ...state,
                isGetStartedBtnShow: action.payload
            }
        case SET_IMAGE: {
            return {
                ...state,
                image: action.payload
            }
        }
        case SET_LABEL: {
            return {
                ...state,
                label: action.payload
            }
        }
        case SET_DESC: {
            return {
                ...state,
                desc: action.payload
            }
        }
        case SET_LINKS: {
            return {
                ...state,
                links: action.payload
            }
        }
        case SET_LIST: {
            return {
                ...state,
                list: action.payload
            }
        }
        case IS_PASTED_CODE_REQUEST:
            return {
                ...state,
                isPastedCodeRequest: action.payload
            }
        case SET_MESSAGE:
            return {
                ...state,
                message: action.payload
            }
        case IS_WIZARD_NAV_ACTIVE: {
            return {
                ...state,
                isWizardNavStatus: action.payload
            }
        }
        case GET_WIZARD_NAV_LENGTH: {
            return {
                ...state,
                wizardNavLength: action.payload
            }
        }
        case INCREASE_WIZARD_NAV_POSITION: {
            return {
                ...state,
                wizardNavPosition: action.payload
            }
        }
        case DECREASE_WIZARD_NAV_POSITION: {
            return {
                ...state,
                wizardNavPosition: action.payload
            }
        }
        case IS_DIVIDER_ACTIVE: {
            return {
                ...state,
                isDividerActive: action.payload
            }
        }
        case SET_IS_GD_UNIT_ADDED_SCRIPT: {
            return {
                ...state,
                isAdUnitAddedScript: action.payload
            }
        }
        case IS_NEXT_BTN_ACTIVE: {
            return {
                ...state,
                isNextBtnActive: action.payload
            }
        }
        case IS_GO_TO_ADSENSE_BTN_SHOW: {
            return {
                ...state,
                isGoToAdSenseBtnShow: action.payload
            }
        }
        case IS_MY_SITE_HAS_BEEN_ADDED: {
            return {
                ...state,
                isMySiteHasBeenAdded: action.payload
            }
        }
        case SET_WIZARD_NAV_LENGTH: {
            return {
                ...state,
                wizardNavLength: action.payload
            }
        }
        case VALIDATION_GD_UNIT_CODE: {
            return {
                ...state,
                adUnitCode: action.payload
            }
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/userAccountWizardReducer.js